import React from 'react'

import { IAlarpThreshold } from 'plugin-codaf-risk-ext-bowtie/types'

import { bowtieTheme } from './constants'

/*
const ACCEPTABLE = 0.00001
const TOLERABLE = 0.001
*/

export type FunctionGetAlarpStatus = (value: number, status: string) => boolean

/**
 * This function receives values of alapthresholds and return a function which compare alarp status and value of event
 * @param alarp thresholds from settings
 * @returns a function which calculates a alarp status
 */
export const getAlarpStatusByName = (alarpThresholds: IAlarpThreshold[]): FunctionGetAlarpStatus => {
    const alarpStatus = Object.entries(alarpThresholds)
        .map(([_, value]) => {
            return {
                ...alarpStatus,
                [value.alarpStatus.name.toUpperCase()]: value.threshold
            }
        })
        .reduce((prev, next) => {
            return {
                ...prev,
                ...next
            }
        }, [])

    return (value: number, status: string) => value < alarpStatus[status]
}

/**
 * This function receives a value of pfd from events and return color based on this value
 * @param value Top event pfd
 * @returns a status color based on pft value
 */
export const getTopEventStatusColor = (value: number, getAlarpStatus: FunctionGetAlarpStatus): string => {
    if (!value || value < 0) {
        return bowtieTheme.topEvent.colorStatus.unknown
    }

    if (getAlarpStatus(value, 'ACCEPTABLE')) {
        return bowtieTheme.topEvent.colorStatus.accetable
    }

    if (getAlarpStatus(value, 'INTOLERABLE')) {
        return bowtieTheme.topEvent.colorStatus.tolerable
    }

    return bowtieTheme.topEvent.colorStatus.intolerable
}

/**
 * This function receives a value of pfd from events and return name based on this value
 * @param value Top event pfd
 * @returns a status name based on pft value
 */
export const getTopEventStatusName = (
    value: number,
    i18n: (l: string) => string,
    getAlarpStatus: FunctionGetAlarpStatus
): string => {
    if (!value || value < 0) {
        return i18n('Invalid event')
    }

    if (getAlarpStatus(value, 'ACCEPTABLE')) {
        return i18n('Acceptable')
    }

    if (getAlarpStatus(value, 'INTOLERABLE')) {
        return i18n('Tolerable')
    }

    return i18n('Unacceptable')
}

/**
 * This function receives a value of pfd from events and return icon based on this value
 * @param value Top event pfd
 * @returns a status icon based on pft value
 */
export const getTopEventStatusIcon = (value: number, getAlarpStatus: FunctionGetAlarpStatus): JSX.Element => {
    if (!value || value < 0) {
        return <></>
    }

    if (getAlarpStatus(value, 'ACCEPTABLE')) {
        return <i className={`export-pdf far fa-check`} style={{ color: '#5cb85c' }} />
    }

    if (getAlarpStatus(value, 'INTOLERABLE')) {
        return <i className={`export-pdf far fa-exclamation`} style={{ color: '#E8B909' }} />
    }

    return <i className="export-pdf far fa-times" style={{ color: '#C43535' }} />
}
